<template>
  <company_contracts_datatable :row-data="contracts" :loading-message="'Loading Contracts...'" :no-rows-message="'No Contracts Loaded'"
                               :columns="contracts_columns" :type="'contracts'" :record-type="'company'"></company_contracts_datatable>
</template>

<script>
import company_contracts_datatable from "datatables/company_contracts_datatable";

export default {
  name: "c_all_contracts",
  components: {
    company_contracts_datatable,
    'linkComponent': {
      name: 'linkComponent',
      data() {
        return {
          web_url: process.env.MIX_WEBSITE_URL
        }
      },
      template: '<a class="view_contract_link" :href="web_url + \'company/contract?link=\' + params.data.link" target="_blank">View</a>'
    }
  },
  data() {
    return {
      company_id: null,
      contracts: [],

      contracts_columns: [
        {headerName: 'Contract Type', field: 'contract_type', minWidth: 130},
        {headerName: 'Contract Start Date', minWidth: 130, valueGetter: this.contract_start_date_value_getter},
        {headerName: 'Contract Length (Months)', field: 'length_months', minWidth: 150},
        {headerName: 'Date Sent', minWidth: 150, valueGetter: this.date_sent_value_getter},
        {headerName: 'Sent To', field: 'sent_to_name', minWidth: 180},
        {headerName: 'Sent By', field: 'user.name', minWidth: 150},
        {headerName: 'Contract Signed', field: 'is_signed_text', minWidth: 100},
        {headerName: 'Link', field: 'link', minWidth: 85, filter: false, cellRendererFramework: 'linkComponent'},
      ]
    }
  },
  beforeMount() {
    axios.get(this.crmApiPath + 'contact/' + this.$store.state.auth.me.contact_id + '/company/show').then(company => {
      this.company_id = company.data.id;
      axios.get(this.crmApiPath + 'company/contract/company/' + company.data.id).then(contracts => this.contracts = contracts.data)
    });
  },
  methods: {
    contract_start_date_value_getter(params) {
      return this.$options.filters.formatDate(params.data.start_date);
    },
    date_sent_value_getter(params) {
      return this.$options.filters.formatDateTime(params.data.created_at);
    }
  }
}
</script>
